export default "__VITE_ASSET__ehQhDGuV__"